import {
  AlertDto,
  AlertWebsocketMessage,
  AlertsBySiteRequest,
  AlertsRequest,
  AlertsResponse,
  DismissAlertRequest,
} from '@core/api/alerting/alerting.models';

import {
  mapAlertSeverityApiModelEnumToStoreModelEnum,
  mapAlertStateApiModelEnumToStoreModelEnum,
  mapAlertStateStoreModelEnumToApiModelEnum,
} from './alerting-enums.mappings';
import {
  AlertDtoStoreModel,
  AlertWebsocketMessageStoreModel,
  AlertsBySiteRequestStoreModel,
  AlertsRequestStoreModel,
  AlertsResponseStoreModel,
  DismissAlertRequestStoreModel,
} from './alerting.models';

export const mapAlertDtoApiModelToStoreModel = (alert: AlertDto): AlertDtoStoreModel => {
  return {
    id: alert.id,
    siteId: alert.siteId,
    type: alert.type,
    subject: alert.subject,
    chargerId: alert.chargerId,
    chargerName: alert.chargerName,
    evseId: alert.evseId,
    evseName: alert.evseName,
    vehicleId: alert.vehicleId,
    vehicleName: alert.vehicleName,
    state: mapAlertStateApiModelEnumToStoreModelEnum(alert.state),
    timestamp: alert.timestamp,
    severity: mapAlertSeverityApiModelEnumToStoreModelEnum(alert.severity),
    actor: alert.actor,
    canResolveManually: alert.canResolveManually,
    sopUrl: alert.sopUrl,
    dismissedReason: alert.dismissedReason,
  };
};

export const mapDismissAlertRequestStoreModelToApiModel = (request: DismissAlertRequestStoreModel): DismissAlertRequest => {
  return {
    reason: request.reason,
  };
};

export const mapAlertWebsocketMessageApiModelToStoreModel = (message: AlertWebsocketMessage): AlertWebsocketMessageStoreModel => {
  return {
    alert: mapAlertDtoApiModelToStoreModel(message.alert),
  };
};

export const mapAlertsBySiteRequestStoreModelToApiModel = (request: AlertsBySiteRequestStoreModel): AlertsBySiteRequest => {
  const requestApiModel: AlertsBySiteRequest = {};

  if (request.states) {
    requestApiModel.states = request.states.map((state) => {
      return mapAlertStateStoreModelEnumToApiModelEnum(state);
    });
  }

  if (request.start) {
    requestApiModel.start = request.start;
  }

  if (request.end) {
    requestApiModel.end = request.end;
  }

  if (request.withSopOnly) {
    requestApiModel.withSopOnly = true;
  }

  if (request.chargerIds) {
    requestApiModel.chargerIds = request.chargerIds;
  }

  if (request.evseIds) {
    requestApiModel.evseIds = request.evseIds;
  }

  if (request.vehicleIds) {
    requestApiModel.vehicleIds = request.vehicleIds;
  }

  return requestApiModel;
};

export const mapAlertsRequestStoreModelToApiModel = (request: AlertsRequestStoreModel): AlertsRequest => {
  const requestApiModel: AlertsRequest = {};

  if (request.siteIds) {
    requestApiModel.siteIds = request.siteIds;
  }

  if (request.tenantIds) {
    requestApiModel.tenantIds = request.tenantIds;
  }

  if (request.states) {
    requestApiModel.states = request.states.map((state) => {
      return mapAlertStateStoreModelEnumToApiModelEnum(state);
    });
  }

  if (request.start) {
    requestApiModel.start = request.start;
  }

  if (request.end) {
    requestApiModel.end = request.end;
  }

  if (request.withSopOnly) {
    requestApiModel.withSopOnly = true;
  }

  if (request.chargerIds) {
    requestApiModel.chargerIds = request.chargerIds;
  }

  if (request.evseIds) {
    requestApiModel.evseIds = request.evseIds;
  }

  if (request.vehicleIds) {
    requestApiModel.vehicleIds = request.vehicleIds;
  }

  return requestApiModel;
};

export const mapAlertsResponseApiModelToStoreModel = (response: AlertsResponse): AlertsResponseStoreModel => {
  return {
    alerts: response.alerts.map((alert) => mapAlertDtoApiModelToStoreModel(alert)),
  };
};
